import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Fab,
} from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchOrgs } from "../../actions";
import { Content } from "../layout";
import { pageLimit as limit } from "../../config/keys";
// import Pagination from "../common/Pagination";
import { fabStyle } from "../common/style";

const OrganizationList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [page, setPage] = useState(0);

  const { count, rows } = useSelector((state) => state.org.organizations);

  useEffect(() => {
    dispatch(fetchOrgs({ page, limit }));
  }, [dispatch, page]);

  const navigateToOrganizationDetail = (id) => {
    navigate(`/organizations/${id}/update`, { state: { id } });
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  const renderOrganizations = () =>
    rows.map((org) => (
      <TableRow
        key={org.id}
        onClick={() => navigateToOrganizationDetail(org.id)}
        sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
      >
        <TableCell>{org.id}</TableCell>
        <TableCell>{org.displayName}</TableCell>
        <TableCell>{org.name}</TableCell>
        {/* <TableCell>{new Date(org.createdAt.seconds * 1000).toLocaleString()}</TableCell> */}
        <TableCell>{new Date(org.createdAt).toLocaleString()}</TableCell>
      </TableRow>
    ));

  return (
    <Content>
      <Card>
        <CardContent>
          <Typography variant="h5" component="div">
            건설사
          </Typography>
          <p />

          <Table
            aria-label="organization-list table"
            sx={{ minWidth: 650, borderRight: 0 }}
          >
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>건설사</TableCell>
                <TableCell>구분값</TableCell>
                <TableCell>등록일시</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>{renderOrganizations()}</TableBody>
          </Table>

          {/* <Pagination updatePage={updatePage} total={count} page={page} /> */}
          <TablePagination
            component="div"
            count={count}
            page={page}
            rowsPerPage={limit}
            onPageChange={handlePageChange}
          />
        </CardContent>
      </Card>
      <Fab
        sx={fabStyle}
        aria-label="add"
        color="primary"
        component={Link}
        to="/organizations/new"
      >
        <AddIcon />
      </Fab>
    </Content>
  );
};

export default OrganizationList;
